/* Dropdayz — bewegende hero's: De Stapel (sneakers) en De Rail (kleding).
   De Ticker op Shop All is pure CSS en heeft hier niets nodig.

   Zelfde contract als De Drop en de keuringslijn:
   - geen libraries, geen afbeeldingen
   - rAF loopt alleen als de hero >= 10% in beeld is EN de tab actief is
   - dt geklemd op 0.033 zodat een trage frame geen sprongen geeft
   - devicePixelRatio begrensd op 2
   - prefers-reduced-motion: een stilstaand frame

   MOBIEL: de canvas meet zichzelf en schaalt de inhoud mee. Onder 700px
   worden dozen en kledingstukken ~30% kleiner, komt de vloer van de stapel
   hoger te liggen (boven het tekstblok) en staat het rek dichter op elkaar,
   zodat animatie en tekst elkaar nooit overlappen.
*/
(function () {
  'use strict';
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start(canvas, draw, init) {
    var ctx = canvas.getContext('2d');
    var W = 0, H = 0, zichtbaar = false, vorige = 0;
    var staat = init();
    function maat() {
      var r = canvas.getBoundingClientRect();
      if (r.width < 2) return;
      var d = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = r.width * d; canvas.height = r.height * d;
      ctx.setTransform(d, 0, 0, d, 0, 0);
      W = r.width; H = r.height;
      if (rm) draw(ctx, W, H, 0, 0, staat);
    }
    maat();
    window.addEventListener('resize', maat);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { zichtbaar = e[0].isIntersecting; }, { threshold: .1 }).observe(canvas);
    } else { zichtbaar = true; }
    if (rm) return;
    requestAnimationFrame(function lus(now) {
      requestAnimationFrame(lus);
      if (!W) { maat(); return; }
      if (!zichtbaar || document.hidden) { vorige = now; return; }
      var dt = Math.min((now - vorige) / 1000, .033) || .016;
      vorige = now;
      draw(ctx, W, H, now / 1000, dt, staat);
    });
  }

  /* ================= DE STAPEL (sneakers) ================= */
  function stapelInit() {
    return { dozen: [], val: null, kantel: 0, kantelV: 0, nr: 0, wachtTot: .7, stof: [], schud: 0,
             maten: ['40','41','42','42.5','43','44','44.5','45'] };
  }
  function tekenDoos(g, d, B, Hd) {
    g.save();
    g.translate(d.x, d.y); g.rotate(d.rot);
    g.fillStyle = '#17171a';
    g.strokeStyle = 'rgba(255,255,255,.85)'; g.lineWidth = 2;
    g.beginPath(); g.rect(-B/2, -Hd, B, Hd); g.fill(); g.stroke();
    g.beginPath(); g.rect(-B/2 - 6, -Hd, B + 12, Hd * .26); g.fill(); g.stroke();
    if (d.blauw) { g.fillStyle = '#30a8e0'; g.fillRect(-B/2, -Hd + Hd*.35, B, Hd*.19); }
    g.fillStyle = d.blauw ? '#fff' : 'rgba(255,255,255,.65)';
    g.font = '700 ' + Math.max(8, B*.055) + 'px Inter, sans-serif';
    g.fillText('DROPDAYZ', -B*.16, -Hd*.2);
    g.fillStyle = 'rgba(255,255,255,.4)';
    g.font = '600 ' + Math.max(7, B*.048) + 'px Inter, sans-serif';
    g.fillText('EU ' + d.maat, B/2 - B*.24, -Hd*.2);
    g.restore();
  }
  function stapelDraw(g, w, h, t, dt, s) {
    g.clearRect(0, 0, w, h);
    var mob = w < 700;
    var f = mob ? .62 : Math.min(1, w / 1100);
    var B = 190 * f, Hd = 62 * f;
    var vloer = mob ? h * .46 : h - 34;
    var bx = mob ? w * .70 : w * .72;

    g.strokeStyle = 'rgba(255,255,255,.16)'; g.lineWidth = 1.5;
    g.beginPath(); g.moveTo(mob ? w*.34 : 0, vloer + 1); g.lineTo(w, vloer + 1); g.stroke();

    if (rm) {
      if (!s.dozen.length) for (var i = 0; i < 4; i++)
        s.dozen.push({ x: bx + (i % 2 ? 7 : -5), y: vloer - i * Hd, rot: (i % 2 ? -.015 : .02), blauw: i === 2, maat: s.maten[i] });
      s.dozen.forEach(function (d) { tekenDoos(g, d, B, Hd); });
      return;
    }

    if (!s.val && t > s.wachtTot && s.kantelV === 0) {
      s.nr++;
      s.val = { x: bx + (Math.random() - .5) * 26 * f, y: -80, vy: 0, rot: (Math.random() - .5) * .14,
                blauw: s.nr % 3 === 0, maat: s.maten[s.nr % s.maten.length] };
    }
    if (s.val) {
      s.val.vy += 2400 * dt; s.val.y += s.val.vy * dt;
      var doelY = vloer - s.dozen.length * Hd;
      if (s.val.y >= doelY) {
        s.val.y = doelY; s.val.rot *= .4;
        s.schud = 7;
        for (var k = 0; k < 7; k++) s.stof.push({ x: s.val.x + (Math.random() - .5) * B, y: doelY, vx: (Math.random() - .5) * 200, vy: -(50 + Math.random() * 130), a: .6 });
        s.dozen.push(s.val); s.val = null;
        s.wachtTot = t + 1.7;
        if (s.dozen.length >= 5) { s.kantelV = .001; s.wachtTot = t + 99; }
      }
    }
    if (s.kantelV > 0) {
      s.kantelV += 2.2 * dt; s.kantel += s.kantelV * dt * 60;
      if (s.kantel > 1.8) { s.dozen = []; s.kantel = 0; s.kantelV = 0; s.wachtTot = t + .9; }
    }
    s.schud *= .86;
    g.save();
    g.translate((Math.random() - .5) * s.schud, (Math.random() - .5) * s.schud);
    s.stof.forEach(function (p) { p.vy += 850 * dt; p.x += p.vx * dt; p.y += p.vy * dt; p.a -= .8 * dt;
      if (p.a > 0 && p.y < vloer + 4) { g.fillStyle = 'rgba(255,255,255,' + p.a + ')'; g.fillRect(p.x, p.y, 3, 3); } });
    s.stof = s.stof.filter(function (p) { return p.a > 0; });
    g.save();
    g.translate(bx, vloer); g.rotate(s.kantel); g.translate(-bx, -vloer);
    s.dozen.forEach(function (d, i) {
      tekenDoos(g, { x: d.x, y: vloer - i * Hd, rot: d.rot + Math.sin(t * 1.6 + i) * .006 * (i + 1), blauw: d.blauw, maat: d.maat }, B, Hd);
    });
    g.restore();
    if (s.val) tekenDoos(g, s.val, B, Hd);
    g.restore();
    g.fillStyle = 'rgba(48,168,224,.9)'; g.font = '700 11px Inter, sans-serif';
    g.fillText('VANDAAG BINNEN: ' + Math.max(s.dozen.length, 1) + ' DOZEN', bx - B / 2, vloer + 22);
  }

  /* ================= DE RAIL (kleding) ================= */
  function railInit() {
    var hangers = [];
    for (var j = 0; j < 16; j++) hangers.push(railHanger(j));
    return { hangers: hangers, t0: 0 };
  }
  function railHanger(i) {
    return { slot: i, x: null, zw: (Math.random() - .5) * .5, fase: Math.random() * 6, blauw: Math.random() < .16, vorm: Math.random() < .5 ? 0 : 1 };
  }
  function railDraw(g, w, h, t, dt, s) {
    g.clearRect(0, 0, w, h);
    var mob = w < 700;
    var SLOT = mob ? 108 : 150;
    var f = mob ? .72 : 1;
    var railY = mob ? h * .10 : h * .16;
    g.strokeStyle = 'rgba(255,255,255,.35)'; g.lineWidth = 3;
    g.beginPath(); g.moveTo(-10, railY); g.lineTo(w + 10, railY); g.stroke();
    if (t - s.t0 > 3.4 && !rm) {
      s.t0 = t;
      s.hangers.forEach(function (p) { p.slot--; p.zw += .35; });
      s.hangers = s.hangers.filter(function (p) { return p.slot > -2; });
      var max = 0;
      s.hangers.forEach(function (p) { if (p.slot > max) max = p.slot; });
      s.hangers.push(railHanger(max + 1));
    }
    s.hangers.forEach(function (p) {
      var doel = 60 + p.slot * SLOT;
      if (p.x === null) p.x = doel;
      p.x += (doel - p.x) * .06;
      if (p.x > w + SLOT) return;
      var hoek = rm ? 0 : Math.sin(t * 2.1 + p.fase) * .085 * (1 + Math.abs(p.zw));
      p.zw *= .985;
      g.save(); g.translate(p.x, railY); g.rotate(hoek); g.scale(f, f);
      g.strokeStyle = 'rgba(255,255,255,.8)'; g.lineWidth = 2;
      g.beginPath(); g.arc(0, 6, 6, Math.PI * .2, Math.PI * 1.4);
      g.moveTo(-4, 11); g.lineTo(-26, 34); g.moveTo(4, 11); g.lineTo(26, 34); g.stroke();
      g.translate(0, 34);
      g.fillStyle = p.blauw ? '#30a8e0' : '#1d1d21';
      g.strokeStyle = 'rgba(255,255,255,.75)'; g.lineWidth = 1.6;
      g.beginPath();
      if (p.vorm === 0) { g.moveTo(-30,0); g.lineTo(-52,26); g.lineTo(-36,38); g.lineTo(-30,30); g.lineTo(-30,118); g.lineTo(30,118); g.lineTo(30,30); g.lineTo(36,38); g.lineTo(52,26); g.lineTo(30,0); g.lineTo(14,8); g.lineTo(-14,8); }
      else { g.moveTo(-26,0); g.lineTo(-34,150); g.lineTo(-6,150); g.lineTo(0,44); g.lineTo(6,150); g.lineTo(34,150); g.lineTo(26,0); g.lineTo(10,6); g.lineTo(-10,6); }
      g.closePath(); g.fill(); g.stroke();
      g.restore();
    });
  }

  function init() {
    document.querySelectorAll('canvas[data-ddz-motion]').forEach(function (c) {
      var soort = c.getAttribute('data-ddz-motion');
      if (soort === 'stapel') start(c, stapelDraw, stapelInit);
      if (soort === 'rail') start(c, railDraw, railInit);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
